import { Button, TextField } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AccountCreateForm } from './account-create-form';
import { List } from 'components/reusable/list';
import { ReusableSelect as Select } from 'components/reusable/select';
import { useGlobalState } from 'store/reducers/reducer';
import { getAccounts } from 'store/sagas/sagas';
import './account-manager.css';
import { useDebounce } from 'utils/hooks';
import { pushFiltersSearchPath, rawParseQuery, transformQueryTypes } from 'utils/url';
const filterOptions = {
    selfServe: [
        { id: 'true', name: 'true' },
        { id: 'false', name: 'false' }
    ],
    isDisabled: [
        { id: 'true', name: 'true' },
        { id: 'false', name: 'false' }
    ],
    pageSize: [
        { id: 10, name: '10' },
        { id: 25, name: '25' },
        { id: 50, name: '50' },
        { id: 100, name: '100' },
        { id: 250, name: '250' },
        { id: 500, name: '500' }
    ]
};
const initialData = {
    name: '',
    selfServe: '',
    page: 1,
    pageSize: 50,
    isDisabled: '',
    firstName: '',
    lastName: '',
    id: '',
    sid: '',
    email: ''
};
const mapData = {
    name: 'string',
    selfServe: 'string',
    page: 'number',
    pageSize: 'number',
    isDisabled: 'string',
    firstName: 'string',
    lastName: 'string',
    id: 'string',
    sid: 'string',
    email: 'string'
};
export const AccountManager = () => {
    const { state } = useGlobalState();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [localState, setLocalState] = useState({
        accounts: [],
        loading: false,
        totalAccounts: 0
    });
    const qsData = transformQueryTypes(mapData, rawParseQuery());
    const [isOpenFilters, setIsOpenFilters] = useState(false);
    const [filter, setFilter] = useState({
        ...initialData,
        ...qsData
    });
    const debouncedFilter = useDebounce(filter, 250);
    const handleGoToAccount = useCallback((accountId) => {
        navigate(`/admin/accounts/${accountId}`);
    }, [navigate]);
    const handlePageChange = (_e, page) => {
        updateFilter({
            ...filter,
            page
        });
    };
    useEffect(() => {
        const { isInitial } = pushFiltersSearchPath({
            filter: debouncedFilter,
            initialData,
            mapData,
            path: pathname
        });
        if (!isOpenFilters && !isInitial) {
            setIsOpenFilters(true);
        }
        setLocalState({
            ...localState,
            loading: true
        });
        getAccounts(state.accessToken, debouncedFilter)
            .then(({ accounts, total }) => {
            setLocalState({
                ...localState,
                accounts,
                totalAccounts: total,
                loading: false
            });
        })
            .catch(() => {
            setLocalState({
                ...localState,
                loading: false
            });
        });
    }, [debouncedFilter]);
    const updateFilter = (newFilter) => {
        setFilter({ ...initialData, ...newFilter });
    };
    const handleChangeFilters = (e) => {
        updateFilter({
            ...filter,
            page: 1,
            [e.target.name]: e.target.value
        });
    };
    const columns = [
        {
            xs: 1,
            name: 'Name',
            id: 'name'
        },
        {
            xs: 1,
            name: 'ID',
            id: 'id'
        },
        {
            xs: 1,
            name: 'SID',
            id: 'sid'
        },
        {
            xs: 2,
            name: 'Email',
            replayMasked: true,
            id: 'email'
        },
        {
            xs: 1,
            name: 'Self-Serve',
            customRenderValue: (item) => {
                return (!!item.subscriptionTier).toString();
            }
        },
        {
            xs: 2,
            name: 'Subscription ID',
            id: 'subscriptionId'
        },
        {
            xs: 2,
            name: 'Customer ID',
            id: 'stripeCustomerId'
        },
        {
            xs: 2,
            name: 'Disabled',
            id: 'isDisabled'
        }
    ];
    const { accounts, loading, totalAccounts } = localState;
    return (React.createElement("div", { className: "account-manager-container" },
        React.createElement(AccountCreateForm, null),
        React.createElement("div", { className: "filters__container" },
            React.createElement("div", { className: "filters", onClick: () => {
                    setIsOpenFilters(!isOpenFilters);
                } },
                React.createElement(FilterListIcon, { style: {
                        color: isOpenFilters ? '#4122af' : 'grey'
                    } }),
                React.createElement("span", null, "Filter")),
            isOpenFilters && (React.createElement("div", { className: "jobs__filters-container-container" },
                React.createElement("div", { className: "jobs-filters-container u-padding-top-medium u-margin-bottom-large" },
                    React.createElement("div", { className: "u-margin-bottom-large" },
                        React.createElement(Select, { className: "g-input-width-16", items: filterOptions.pageSize, label: "Page Size", name: "pageSize", onChange: handleChangeFilters, value: filter.pageSize }),
                        React.createElement(TextField, { className: "u-margin-bottom-small g-input-width-16", label: "Id", name: "id", onChange: handleChangeFilters, value: filter.id }),
                        React.createElement(TextField, { className: "u-margin-bottom-small g-input-width-16", label: "Sid", name: "sid", onChange: handleChangeFilters, value: filter.sid }),
                        React.createElement(TextField, { className: "u-margin-bottom-small g-input-width-16", label: "Email", name: "email", onChange: handleChangeFilters, value: filter.email }),
                        React.createElement(TextField, { className: "u-margin-bottom-small g-input-width-16", label: "Name", name: "name", onChange: handleChangeFilters, value: filter.name }),
                        React.createElement(TextField, { className: "u-margin-bottom-small g-input-width-16", label: "First Name", name: "firstName", onChange: handleChangeFilters, value: filter.firstName }),
                        React.createElement(TextField, { className: "u-margin-bottom-small g-input-width-16", label: "Last Name", name: "lastName", onChange: handleChangeFilters, value: filter.lastName }),
                        React.createElement(Select, { className: "g-input-width-16", items: filterOptions.selfServe, label: "Self Serve", name: "selfServe", onChange: handleChangeFilters, value: filter.selfServe }),
                        React.createElement(Select, { className: "g-input-width-16", items: filterOptions.isDisabled, label: "Disabled", name: "isDisabled", onChange: handleChangeFilters, value: filter.isDisabled })),
                    React.createElement("div", { className: "u-margin-bottom-large" },
                        React.createElement(Button, { color: "primary", onClick: () => {
                                updateFilter(initialData);
                            } }, "Clear")))))),
        React.createElement("div", { className: "account-grid" },
            React.createElement(List, { columns: columns, handlePageChange: handlePageChange, isClickable: () => true, items: accounts, label: "Accounts", loading: loading, onClick: (item) => {
                    handleGoToAccount(item.id);
                }, page: filter.page, total: totalAccounts, totalPages: Math.ceil(totalAccounts / filter.pageSize) }))));
};
